





























































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import Component from "vue-class-component";
import { FormPlugin, FormGroupPlugin, FormInputPlugin, ButtonPlugin, SpinnerPlugin, FormSelectPlugin, FormFilePlugin } from "bootstrap-vue";
import { ModifyUser, User } from "../../models/user.model";
import { Watch } from "vue-property-decorator";
import { RootActionTypes, RootState } from "../../store";
import { City } from "../../models/city.model";
import { AuthState, namespaceAuth, AuthActionTypes } from "../../store/auth";
import Vuelidate from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";

Vue.use(FormPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(ButtonPlugin);
Vue.use(SpinnerPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormFilePlugin);
Vue.use(Vuelidate);

@Component({
  name: "ProfilePageEdit",
  computed: {
    ...mapState<AuthState>(namespaceAuth, {
      user: (state: AuthState) => state.user
    }),
    ...mapState<RootState>({
      cityOptions: (state: RootState) => state.cities.map<{ value: string; text: string }>(city => ({ value: city.name, text: city.name }))
    })
  },
  data() {
    return {
      form: {
        username: "",
        lastname: "",
        firstname: "",
        phone: "",
        profile_picture: null,
        nationality: "",
        city_live: "",
        favorite_team: "",
        mother_name: "",
        birth_date: ""
      } as ModifyUser,
      profilePictureSrc: "",
      isLoading: false
    };
  },
  validations: {
    form: {
      username: {
        required
      },
      lastname: {
        required
      },
      firstname: {
        required
      },
      phone: {
        required
      },
      birth_date: {
        required
      },
      mother_name: {
        required
      },
      city_live: {},
      favorite_team: {},
      nationality: {},
      profile_picture: {
        required: requiredIf((form: ModifyUser, vm: Vue) => {
          return vm ? !!(vm as ProfilePageEdit).profilePictureSrc : null;
        })
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]!;
      return $dirty ? !$error : null;
    }
  }
})
export default class ProfilePageEdit extends Vue {
  form!: ModifyUser;
  profilePictureSrc!: string | File;
  isLoading!: boolean;

  mounted() {
    this.$store.dispatch(`${RootActionTypes.FetchCities}`);
  }

  @Watch("user", { immediate: true })
  onUserChanged(newUser: User) {
    if (this.$v.form && newUser) {
      this.$v.form.$model = this.userToFormModel(newUser);
      this.$v.form.$touch();

      this.profilePictureSrc = newUser.profile_picture;
    }
  }

  onFileChanged(file: File | string) {
    if (file instanceof File) {
      this.profilePictureSrc = URL.createObjectURL(file);
    }
  }

  async onSubmit(event: Event) {
    event.preventDefault();
    this.isLoading = true;

    const modifyUser = this.form;
    if (!modifyUser.profile_picture) delete modifyUser.profile_picture;

    await this.$store.dispatch(`${namespaceAuth}/${AuthActionTypes.ModifyUser}`, modifyUser);
    this.isLoading = false;
    if (this.$v.form) {
      this.$v.form.$reset();
    }
  }

  private userToFormModel(user: User): ModifyUser {
    const { username, lastname, firstname, phone, profile_picture, nationality, city_live, favorite_team, mother_name, birth_date } = user;
    return {
      username,
      lastname,
      firstname,
      phone,
      profile_picture: null,
      nationality,
      city_live,
      favorite_team,
      mother_name,
      birth_date: this.$moment(birth_date).format("YYYY-MM-DD")
    };
  }
}
